import dalmia_logo from "../assets/logos/dalmia-cement-logo.png";
import chettinadu_logo from "../assets/logos/Chettinad-logo.png";
import jswcements_logo from "../assets/logos/jswsteel-logo.svg";
import mahacements_logo from "../assets/logos/maha-cements-logo.jpeg";
import vizag_logo from "../assets/logos/rinl-vizag-steel-seeklogo.png";
import ultratech_logo from "../assets/logos/ultratech-cement-logo.png"
import { motion } from "framer-motion";

const PARTNER_BRANDS = [
  { id: 1, logo: chettinadu_logo },
  { id: 2, logo: dalmia_logo },
  { id: 3, logo: jswcements_logo },
  { id: 4, logo: mahacements_logo},
  { id: 5, logo: vizag_logo},
  { id: 6, logo: ultratech_logo },
];

export default function PartnerCarousel() {
  const brands = [...PARTNER_BRANDS, ...PARTNER_BRANDS];

  return (
    <section className="py-24 bg-obsidian relative overflow-hidden">

      {/* Heading */}
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-white">
          Trusted <span className="text-gold">Partners</span>
        </h2>
      </div>

      {/* Carousel */}
      <div className="relative overflow-visible">

        {/* Left fade */}
        <div className="absolute left-0 top-0 h-40 w-40 bg-gradient-to-r from-obsidian to-transparent z-10 pointer-events-none" />

        {/* Right fade */}
        <div className="absolute right-0 top-0 h-40 w-40 bg-gradient-to-l from-obsidian to-transparent z-10 pointer-events-none" />

        <motion.div
          className="flex gap-24 items-center w-max"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            ease: "linear",
            duration: 40,
            repeat: Infinity,
          }}
        >
          {brands.map((brand, index) => (
            <img
              key={index}
              src={brand.logo}
              alt="partner"
              className="h-12 md:h-20 w-auto object-contain 
              grayscale opacity-70 
              hover:grayscale-0 hover:opacity-100 
              hover:scale-110
              transition duration-300"
            />
          ))}
        </motion.div>

      </div>
    </section>
  );
};
